import { FormGroup } from '@angular/forms';

export class BaseClass {

    formGroup: FormGroup;
    _errors = {} || '';

    constructor(){}

    /**
     * Disable formgroup
     */
    disableForm(){
        Object.keys(this.formGroup.controls).forEach(key => {
           this.formGroup.controls[key].disable();
         });
        return this.formGroup;
    }

    /**
     * Enable formgroup
     */
    enableForm(){
        Object.keys(this.formGroup.controls).forEach(key => {
           this.formGroup.controls[key].enable();
         });
        return this.formGroup;
    }

   /**
   * Error data
   * trigging Error per field
   * @param err 
   */
    triggerErrors(err:any) {
        Object.keys(this.formGroup.controls).forEach(key => {
            if (err[key]) {
              this.formGroup.controls[key].setErrors({'invalid': true});
              this.formGroup.controls[key].markAsTouched();
              this.formGroup.controls[key].markAsDirty();
            }
        });
        return this.formGroup;
    }
    
    /**
     * Reset error outline
     */
    resetErrors(){
        Object.keys(this.formGroup.controls).forEach(key => {
            this.formGroup.controls[key].setErrors({'invalid': false});
            this.formGroup.controls[key].markAsUntouched();
            this.formGroup.controls[key].markAsPristine();
          });
        this._errors = {};
        return this.formGroup;  
    }

    /**
     * Error message as Object
     * @param err 
     */
    setErrors(err) {
        this._errors = err;
     }

}    